<script>
import { mapActions, mapState } from "vuex";
import MainButton from "@/components/helpers/MainButton.vue";
import { format } from "date-fns";
import MainLoader from "@/components/helpers/MainLoader.vue";

export default {
  name: "StatisticsTab",
  components: { MainLoader, MainButton },

  data() {
    return {
      isLoading: false,
      countryNames: {
        UZB: "Узбекистану",
        KGZ: "Кыргызстану",
      },
    };
  },

  computed: {
    ...mapState({
      selectedBinaryAccount: (state) => state.auth.selectedBinaryAccount,
      currentCountry: (state) => state.internationalOperations.currentCountry,
      statisticInfo: (state) => state.balance.statisticInfo,
    }),

    formattedTime() {
      return format(
        new Date(this.statisticInfo.last_refresh),
        "dd.MM.yyyy HH:mm"
      );
    },
  },

  watch: {
    selectedBinaryAccount() {
      this.loadData();
    },
  },

  methods: {
    ...mapActions({
      loadStatistic: "balance/loadStatistic",
    }),

    goToTariffs() {
      this.$router.push({
        name: "Tariffs",
      });
    },

    async loadData() {
      if (!this.selectedBinaryAccount?.id) {
        return;
      }

      const params = {
        binaryAccount: this.selectedBinaryAccount?.id,
        region: this.currentCountry,
      };

      this.isLoading = true;
      try {
        await this.loadStatistic(params);
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.loadData();
  },
};
</script>

<template>
  <div class="statistics-tab">
    <MainLoader v-if="isLoading" />

    <div v-else-if="!selectedBinaryAccount" class="empty-condition">
      <p>
        Чтобы получить доступ ко всем возможностям , необходим тариф
        <span>Бизнес</span> или выше
      </p>

      <MainButton title="Сменить тариф" color="gold" @click="goToTariffs" />
    </div>

    <template v-else-if="statisticInfo?.data">
      <div class="statistics-tab__main-info">
        <h5>Приглашенные по {{ countryNames[currentCountry] }}</h5>

        <div class="statistics-tab__card-list">
          <div class="statistics-tab__card">
            <h5>Все</h5>
            <p>{{ statisticInfo.data?.without_tsp_count }}</p>
          </div>

          <div class="statistics-tab__card">
            <h5>Лично</h5>
            <p>{{ statisticInfo.data?.self_count }}</p>
          </div>

          <div class="statistics-tab__card">
            <h5>Сеть</h5>
            <p>{{ statisticInfo.data?.distributor_count }}</p>
          </div>
        </div>
      </div>

      <div class="statistics-tab__footer">
        <h5>Последнее обновление: {{ formattedTime }}</h5>

        <p>Статистика обновляется каждые 4 часа</p>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.statistics-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__main-info {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > h5 {
      color: var(--text-dark-fifth, #666);

      @include text-2;
    }
  }

  &__card-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 8px;
  }

  &__card {
    border-radius: 8px;
    background: var(--background-light-primary, #fff);

    box-shadow: 0 0 30px 0 rgba(169, 169, 169, 0.15);
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 12px;

    > h5 {
      color: var(--text-dark-third, #474747);

      @include caption-1;
    }

    > p {
      color: var(--text-dark-primary, #212121);

      @include body-1-bold;
    }
  }

  &__footer {
    display: flex;
    flex-direction: column;
    gap: 4px;

    > h5 {
      color: var(--text-dark-primary, #212121);

      @include text-2;
    }

    > p {
      color: var(--text-dark-fifth, #666);

      @include caption-1;
    }
  }

  .empty-condition {
    max-width: 418px;

    > p {
      color: var(--text-dark-primary);
      margin-bottom: 32px;

      @include body-1;

      > span {
        @include body-1-bold;
      }
    }

    > button {
      width: 300px;
    }
  }
}
</style>
